/**
 * userApply接口
 */
import axios from '../utils/https' // 导入http中创建的axios实例

const userApply = {
  getUserApplyList (params) {
    return axios.get('/api/userApply/GetUserApplyList', { params })
  },
  getVoteUserApplyListByGroup (params) {
    return axios.get('/api/userApply/GetVoteUserApplyListByGroup', { params })
  },
  getUserApply (params) {
    return axios.get('/api/userApply/GetUserApply', { params })
  },
  editUserApply (params) {
    return axios.post('/api/userApply/EditUserApply', params)
  },
  systemEditUserApply (params) {
    return axios.post('/api/userApply/SystemEditUserApply', params)
  },
  deleteUserApply (params) {
    return axios.delete('/api/userApply/DeleteUserApply', { params })
  },
  passUserApply (params) {
    return axios.post('/api/userApply/PassUserApply', params)
  },
  rejectUserApply (params) {
    return axios.post('/api/userApply/RejectUserApply', params)
  },
  rejectUserApplys (params) {
    return axios.post('/api/userApply/RejectUserApplys', params)
  },
  userApplyManageGroup (params) {
    return axios.post('/api/userApply/UserApplyManageGroup', params)
  },
  getUserApplyAddPushGroups (params) {
    return axios.get('/api/userApply/GetUserApplyAddPushGroups', { params })
  },
  userApplyAddPushGroup (params) {
    return axios.post('/api/userApply/UserApplyAddPushGroup', params)
  },
  userApplysPushGroups (params) {
    return axios.post('/api/userApply/UserApplysPushGroups', params)
  },
  groupAddUserApply (params) {
    return axios.post('/api/userApply/GroupAddUserApply', params)
  },
  alreadyReadUserApply (params) {
    return axios.post('/api/userApply/AlreadyReadUserApply', params)
  },
  exportUserApplys (params) {
    return axios({
      method: 'post',
      url: '/api/userApply/ExportUserApplys',
      data: params,
      responseType: 'blob'
    })
  }
}

export default userApply
